import type { Location } from '@/models';
import { getBearing, getDistanceInMeters } from '@/lib/geoCalcUtil';

// 待機中の駐車車両も isMoving になるため、GPSの揺れで向きが回らないよう、この距離未満の移動では向きを更新しない
export const CAR_BEARING_MIN_MOVE_METERS = 10;

export interface CarBearingRecord {
  lat: number;
  lon: number;
  bearing: number | null;
}

export const shouldUpdateCarBearing = (distanceMeters: number): boolean => {
  return distanceMeters >= CAR_BEARING_MIN_MOVE_METERS;
};

export const updateCarBearingRecord = (
  previous: CarBearingRecord | null,
  current: Location,
): CarBearingRecord | null => {
  if (!Number.isFinite(current.lat) || !Number.isFinite(current.lon)) return previous;
  if (!previous) return { ...current, bearing: null };

  if (!shouldUpdateCarBearing(getDistanceInMeters(previous, current))) return previous;

  return { ...current, bearing: getBearing(previous, current) };
};

export interface CarDirectionArrowParams {
  showDirectionArrow: boolean;
  hideCarIcons: boolean;
  isMoving: boolean;
  bearing: number | null;
}

// 進行方向の矢印に使う方位（ラジアン）を返す。矢印を出さない場合は null
export const getCarDirectionArrowBearing = ({
  showDirectionArrow,
  hideCarIcons,
  isMoving,
  bearing,
}: CarDirectionArrowParams): number | null => {
  if (!showDirectionArrow || !hideCarIcons || !isMoving) return null;

  return bearing;
};
